import { MessageProcessor } from '@/services/websocketProcessorTypes'
import store from '@/redux/store'
import { AIPlayerMessage } from '@/redux/types/playerChatbot'
import {
  addMessage,
  incrementUnread,
  setError,
  setThread,
} from '@/redux/slices/aiPlayerChatSlice'
import { AIPlayerSenderType, isAIPlayerTab } from '@/constants/chat'

export const aiPlayerProcessors: MessageProcessor[] = [
  {
    type: 'ai_player_thread',
    handler: (data) => {
      store.dispatch(setThread(data))
    },
  },
  {
    type: 'ai_player_message',
    handler: (data) => {
      const { type: _type, ...rest } = data as Record<string, unknown> & {
        type?: string
      }
      const message = rest as AIPlayerMessage
      const state = store.getState()
      const isNew = !state.aiPlayerChat.messages.some((m) => m.id === message.id)
      const isFromBot = message.sender_type === AIPlayerSenderType.Bot
      const isActive = isAIPlayerTab(state.chat.activeTab)

      store.dispatch(addMessage(message))

      if (isNew && isFromBot && !isActive) {
        store.dispatch(incrementUnread())
      }
    },
  },
  {
    type: 'ai_player_error',
    handler: (data) => {
      store.dispatch(setError(data.error || 'AI player error'))
    },
  },
]
